import { useMutation } from '@tanstack/react-query';

import { RestApiError } from 'services/api/restful/errors';
import { markUnsupportedDevice } from 'services/api/restful/generated/accounts/accounts';

export const useMarkUnsupportedDevice = () => {
  const mutation = useMutation<void, RestApiError, void>({
    mutationFn: async () => {
      await markUnsupportedDevice();
    },
  });

  return {
    markUnsupportedDevice: mutation.mutate,
    isLoading: mutation.isPending && !mutation.isPaused,
    isError: mutation.isError,
  };
};
